/**
 * @author      yontaek@zumper.com (Yon Taek Chung)
 * @copyright   Copyright (c) 2022, Zumper
 * @description AutocompleteSubmitButton
 */

import { Button, useTheme } from '@chakra-ui/react'
import type { ChakraZ4Type } from '@zcode-ui/chakra-themes'
import { Search } from '@zcode-ui/icons'
import React from 'react'

export interface AutocompleteSubmitButtonProps {
  hoveredIndex: number
  onSubmit: (
    e: React.MouseEvent<HTMLButtonElement>,
    hoveredIndex: number,
    searchTerm: string
  ) => void
  searchTerm: string
}

export const AutocompleteSubmitButton = ({
  hoveredIndex,
  onSubmit,
  searchTerm,
}: AutocompleteSubmitButtonProps) => {
  const { colors } = useTheme<ChakraZ4Type>()

  const handleSearch = (e: React.MouseEvent<HTMLButtonElement>) => {
    onSubmit(e, hoveredIndex, searchTerm)
  }

  return (
    <Button
      aria-label="Search"
      onClick={handleSearch}
      minH={12}
      position="absolute"
      right="-56px"
      variant="pink"
      w={12}
      type="submit"
    >
      <Search fill={colors?.backgroundLightest} />
    </Button>
  )
}
